import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames/bind";
import styles from "./Header.module.scss";
import { openAppOrStoreDesktopAware } from "../../utils/deeplink";
import DownloadModal from "../DownloadModal/DownloadModal";

const cx = classNames.bind(styles);

export default function Header() {
  const headerRef = useRef(null);
  const [activeSection, setActiveSection] = useState("");
  const [openDownload, setOpenDownload] = useState(false); // 데스크톱 모달

  useEffect(() => {
    const handleScrollListen = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const sections = ["home", "service", "faq"];
      const currentScrollY = window.scrollY;

      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section) {
          const sectionTop = section.offsetTop - headerHeight;
          const sectionBottom = sectionTop + section.offsetHeight;

          if (currentScrollY >= sectionTop && currentScrollY < sectionBottom) {
            setActiveSection(sectionId);
            return;
          }
        }
      }
      setActiveSection("");
    };

    window.addEventListener("scroll", handleScrollListen);
    return () => {
      window.removeEventListener("scroll", handleScrollListen);
    };
  }, []);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element && headerRef.current) {
      const headerHeight = headerRef.current.offsetHeight;
      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  // 다운로드 버튼: 모바일은 앱 실행→스토어 폴백, 데스크톱은 모달 열기
  const handleDownloadClick = () => {
    // 반드시 "사용자 클릭" 이벤트 안에서 호출
    openAppOrStoreDesktopAware({
      onDesktop: () => setOpenDownload(true),
    });
  };

  return (
    <>
      <div ref={headerRef} className={cx("container")}>
        <img className={cx("logo")} src="/images/logo.png" alt="logo" />
        <div className={cx("nav-box")}>
          <div className={cx("nav-item-box")}>
            <button
              onClick={() => handleScroll("home")}
              className={cx("nav-button", { active: activeSection === "home" })}
            >
              Home
            </button>
            <button
              onClick={() => handleScroll("service")}
              className={cx("nav-button", {
                active: activeSection === "service",
              })}
            >
              Service
            </button>
            <button
              onClick={() => handleScroll("faq")}
              className={cx("nav-button", { active: activeSection === "faq" })}
            >
              FAQ
            </button>
          </div>
          <button
            onClick={handleDownloadClick}
            className={cx("download-button")}
          >
            <img
              className={cx("download-img")}
              src="/images/download-button.png"
              alt="download-button"
            />
          </button>
        </div>
      </div>
      <div className={cx("header-empty-box")} />
      <DownloadModal
        open={openDownload}
        onClose={() => setOpenDownload(false)}
      />
    </>
  );
}
